export const isObject = (val: unknown): val is Record<any, any> => val !== null && typeof val === 'object';

export const isDef = <T>(val: T): val is NonNullable<T> => val !== undefined && val !== null;

export function get(object: any, path: string): any {
  const keys = path.split('.');
  let result = object;

  keys.forEach((key) => {
    result = isObject(result) ? result[key] ?? '' : '';
  });

  return result;
}
